<ng-template appSpinnerContent></ng-template>
